import React from "react";
import { AccordionSummary } from "@mui/material";
import DropdownIcon from "../dropdown/icon";
import { ParentProps } from "../types";
import "./styles.scss";

const classBase = "scd-accordion-summary";

export function ScdAccordionSummary({
  children,
  ...other
}: ParentProps): React.JSX.Element {
  return (
    <AccordionSummary
      expandIcon={<DropdownIcon />}
      aria-controls="panel1a-content"
      id="panel1a-header"
      classes={{
        root: `${classBase}`,
        expanded: `${classBase}-expanded`,
        focusVisible: `${classBase}-focused`,
        disabled: `${classBase}-disabled`,
        content: `${classBase}-content`,
        expandIconWrapper: `${classBase}-icon`,
      }}
      {...other}
    >
      {children}
    </AccordionSummary>
  );
}
